import { LOADING, SET_FEATURE_FLAG } from "../actionTypes";

export const setLoading = (value) => {
  return {
    type: LOADING,
    payload: value,
  };
};

export const setFeatureFlag = (value) => {
  return {
    type: SET_FEATURE_FLAG,
    payload: value,
  };
};
